<div class="required-documents-item-header clearfix" (click)="!document.somenteDownload && fileInput.click()">
  <div class="required-documents-item-image-wrapper col-xs-2">
    <div class="required-documents-item-check" *ngIf="hasFile">
      <em class="required-documents-item-check-icon glyphicon glyphicon-ok"></em>

      <span class="required-documents-item-check-badge"></span>
    </div>
  </div>

  <div class="col-xs-8">
    <div class="required-documents-item-name">
      {{ document.descPendencia || document.descDocto }}
    </div>
    <div class="sub-documents-item" *ngFor="let item of document.tiposDocumentos">
      {{ item.descricao }}
    </div>
  </div>

  <div class="required-documents-item-icon-wrapper col-xs-2">
    <em class="required-documents-item-icon-upload" *ngIf="!document.somenteDownload && hasUploadDefined && !hasFile"></em>
    <a [href]="document.url" target="_blank" *ngIf="document.url" (click)="$event.stopPropagation();" title="Visualizar arquivo">
      <em class="required-documents-item-icon-printer"></em>
    </a>
    <em class="required-documents-item-icon" *ngIf="!hasUploadDefined"></em>
  </div>
</div>

<div class="required-documents-item-body" *ngIf="hasFile">
  <ul class="selected-files">
    <li class="selected-files-item" *ngFor="let file of files; index as fi">
      <div class="col-xs-6 selected-files-item-name">{{ file.name }}</div>

      <div class="col-xs-6 text-right">
        <button class="selected-files-remove-button" aria-label="Remover" (click)="removeFileCallback(files, fi)">
          <em class="glyphicon glyphicon-trash"></em>
        </button>
      </div>
    </li>
  </ul>

  <button
    type="button"
    class="selected-files-remove-all-button btn btn-primary btn-xs"
    *ngIf="files.length > 1"
    (click)="removeAllFilesCallback(filesDocuments, documentIndex)"
  >
    <span class="selected-files-remove-all-icon glyphicon glyphicon-trash"></span>

    Remover todos
  </button>
</div>

<span class="hidden">
  <input
    #fileInput
    type="file"
    multiple
    (change)="fileChange.emit($event)"
    [accept]="acceptFiles"
  />
</span>
